import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

const EmptyTable = () => {
  const { t } = useTranslation();

  return (
    <div className='tr tr--hover-disabled empty-table'>
      <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className='empty-table_icon' />
      {t('noData')}
    </div>
  );
};

export default memo(EmptyTable);
